module.exports = __webpack_public_path__ + "img/zbj@2x.4f0786a7.png";